import React, { useState } from "react";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const SHEETY_API_URL =
    "https://api.sheety.co/8665b8fb05801f2a465ec0b3b8dcdc28/bestRate/customer";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      alert("Please enter a valid email address.");
      return;
    }

    const data = {
      customer: {
        email: email,
        mortgage: "No",
        auto: "No",
        credit: "No",
        personal: "No",
        location: "Not Provided",
        county: "Not Provided",
      },
    };

    try {
      const response = await fetch(SHEETY_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setSubmitted(true);
        console.log("Email successfully submitted:", email);
      } else {
        console.error("Failed to submit email:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="email-signup-container" style={{ textAlign: 'center', marginTop: '30px' }}>
      {!submitted ? (
        <form onSubmit={handleSubmit} style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
          <label htmlFor="email" style={{ whiteSpace: 'nowrap' }}>
            Sign up for email updates on the best rates
          </label>
          <input
            type="email"
            id="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              padding: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />
          <button
            type="submit"
            style={{
              padding: '8px 15px',
              border: 'none',
              backgroundColor: '#007BFF',
              color: 'white',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Submit
          </button>
        </form>
      ) : (
        <p>Thanks for signing up!</p>
      )}
    </div>
  );
};

export default SignUp;
